import { useTranslation } from "react-i18next"
import { useAppSelector } from "@/reducers/hooks"
import { selectTabs, TAB_TYPES } from "@/reducers/tabsSlice"
import type * as React from "react"
import { useCallback, useContext } from "react"
import { useSidebar } from "@/components/sidebar/SidebarContext"
import BaseSidebarButton from "./BaseSidebarButton"
import { allUnreadCount } from "@/reducers/chatsSliceSelectors"
import { XmppContext } from "@/stream/xmppClient"
import {
  MessageBubbleIcon,
  MessageBubbleIconActive,
} from "@/components/icons/MessageBubbleIcon"

const ChatListSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { myJid } = useContext(XmppContext)

  const { previousActiveChat } = useAppSelector(selectTabs)
  const { onActiveChatChange } = useSidebar()

  const handleChatsClick = useCallback(() => {
    if (previousActiveChat) {
      onActiveChatChange(previousActiveChat)
    }
  }, [previousActiveChat, onActiveChatChange])

  const unreadCount = useAppSelector(allUnreadCount(myJid.toString()))

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.CHATS}
      icon={MessageBubbleIcon}
      activeIcon={MessageBubbleIconActive}
      tooltipText={t("app.sidebar.chats")}
      className={className}
      onClick={handleChatsClick}
    >
      {unreadCount > 0 && (
        <div className="absolute right-[-3px] top-[-3px] z-[99999] flex h-4 min-w-4 items-center justify-center rounded-lg bg-base-primary p-1 text-[10px] font-semibold text-white">
          {unreadCount}
        </div>
      )}
    </BaseSidebarButton>
  )
}

export default ChatListSidebarButton
